import { breakpoints } from '@madeiramadeirabr/theme';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

interface IProductListingContextProps {
  mainIndex: string;
  currentIndex: string;
  setCurrentIndex: (arg: string) => void;
  currentListNameId: string;
  setCurrentListNameId: (arg: string) => void;
  deviceType: string;
  isFiltered: boolean;
  setIsFiltered: (arg: boolean) => void;
  isFreeFreightFilterActive: boolean;
  setIsFreeFreightFilterActive: (arg: boolean) => void;
}

export const ProductListingContext = createContext<IProductListingContextProps>(null);

interface IProductListingStorageProps {
  children: ReactNode;
  initialIndex: string;
  serverDeviceType?: 'mobile' | 'desktop';
}

export function ProductListingStorage({
  children,
  initialIndex,
  serverDeviceType,
}: IProductListingStorageProps): JSX.Element {
  const [currentIndex, setCurrentIndex] = useState<string>(initialIndex);
  const [currentListNameId, setCurrentListNameId] = useState<string>('');
  const [isFiltered, setIsFiltered] = useState<boolean>(false);
  const [isFreeFreightFilterActive, setIsFreeFreightFilterActive] = useState<boolean>(false);

  const { md } = breakpoints;

  const mediaDeviceType = useMediaQuery({ minWidth: md }) ? 'desktop' : 'mobile';
  const deviceType = serverDeviceType ?? mediaDeviceType;

  const contextValue: IProductListingContextProps = useMemo(
    () => ({
      mainIndex: initialIndex,
      currentIndex,
      setCurrentIndex,
      currentListNameId,
      setCurrentListNameId,
      deviceType,
      isFiltered,
      setIsFiltered,
      isFreeFreightFilterActive,
      setIsFreeFreightFilterActive,
    }),
    [
      currentIndex,
      currentListNameId,
      deviceType,
      initialIndex,
      isFiltered,
      isFreeFreightFilterActive,
    ]
  );

  return (
    <ProductListingContext.Provider value={contextValue}>{children}</ProductListingContext.Provider>
  );
}

export const useProductListing = (): IProductListingContextProps =>
  useContext(ProductListingContext);
